import Page from './container'
export default Page
